import React, { useEffect, useState } from 'react';
import LoginForm from '../../parts/LoginForm';
import RegistrationForm from '../../parts/RegistrationForm';
 
function LoginRegistration (){

    return (
        <section className="faith">
            <div className="container" style={{position: 'relative'}}>
                <div className="parent">
                    <div className="co-parent">
                    {/* Login navigation */}
                        <div className="container card mx-0 px-0 login-container" id="login-wrap">
                        
                            <nav className="navigation-login">
                                <div className="nav nav-tabs" id="nav-tab" role="tablist">
                                <button className="nav-link active" id="nav-home-tab" data-bs-toggle="tab" data-bs-target="#nav-home" type="button" role="tab" aria-controls="nav-home" aria-selected="true">User Login</button>
                                <button className="nav-link " id="nav-contact-tab" data-bs-toggle="tab" data-bs-target="#nav-contact" type="button" role="tab" aria-controls="nav-contact" aria-selected="false">Registration</button>
                                </div>
                            </nav>
                            <div className="tab-content" id="nav-tabContent">
                                <div className="tab-pane fade show active" id="nav-home" role="tabpanel" aria-labelledby="nav-home-tab">
                                    
                                <div className="row">
                                    <div className="col-md-12">
                                        <LoginForm />
                                    </div>
                                </div>
                                </div>
                                <div className="tab-pane fade" id="nav-contact" role="tabpanel" aria-labelledby="nav-contact-tab">
                                    <RegistrationForm />
                            </div>
                        </div>
                    </div>
                </div>
                {/* End Login navigation  */}
                </div>
            </div>
        </section>
    )
}
 
export default LoginRegistration;